export default "__VITE_ASSET__C0Fn2ruI__"